export default class CheckBoxItemNodeView {
    constructor(node, view, getPos) {
        this.view = view;
        this.getPos = getPos;
        this.node = node;

        const listItem = document.createElement('li');
        listItem.className = 'task-list-item';

        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = 'task-list-item-checkbox';
        if (node.attrs.checked === true) {
            listItem.className = 'task-list-item checked';
            checkbox.checked = true;
            checkbox.setAttribute('checked', 'checked');
        }
        checkbox.addEventListener('click', e => this.handleClick(e))

        const listCheckbox = document.createElement('span');
        listCheckbox.setAttribute('contenteditable', 'false');
        listCheckbox.appendChild(checkbox);

        const listText = document.createElement('div');

        listItem.appendChild(listCheckbox);
        listItem.appendChild(listText);

        this.dom = listItem;
        this.contentDOM = listText;
    }

    handleClick(e) {
        e.preventDefault();
        const transaction = this.view.state.tr.setNodeMarkup(this.getPos(), undefined, {
            checked: e.target.checked,
        });
        this.view.dispatch(transaction);
    }

    destroy() {
        this.dom.remove();
        this.contentDOM.remove();
        delete this.dom;
        delete this.contentDOM;
    }
}